import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { OptionLicense } from '../models/option-licence.model';
import { TenantLicense } from '../models/tenant-license.model';
import { ApiEndpoint } from './rest/rest.model';
import { RestService } from './rest/rest.service';

@Injectable()
export class TenantLicenseService {
  constructor(private rest: RestService) {}
  public getTenant(): TenantLicense[] {
    const list: TenantLicense[] = [];
    this.rest.getCall(ApiEndpoint.TENANT_LICENSE, true, {size: 100}).subscribe((t: any) => {
      t._embedded.license.forEach((tenant: TenantLicense) => {
        tenant.optionListNames = this.getOptionsNames(tenant.tenant);
        list.push(new TenantLicense(tenant));
      });
    });
    return list;
  }
  public saveTenant(tenantLicense: TenantLicense): Observable<TenantLicense> {
    tenantLicense = TenantLicense.format(tenantLicense);
    return this.rest
      .postCall(ApiEndpoint.TENANT_LICENSE, tenantLicense)
      .pipe(map((tenant) => new TenantLicense(tenant)));
  }

  public updateTenant(tenantLicense: TenantLicense): Observable<TenantLicense> {
    tenantLicense = TenantLicense.format(tenantLicense);
    const tenantId = tenantLicense.tenant;
    return this.rest
      .putCall(ApiEndpoint.TENANT_LICENSE_UPDATE, tenantLicense, { tenantId })
      .pipe(map((tenant) => new TenantLicense(tenant)));
  }

  public getUsers(tenantId: string):  Observable<any>  {
    return this.rest
      .getCall(ApiEndpoint.USER_LICENSE, true, { tenantId });
  }

  public getOptions(tenantId: string): Observable<any> {
    return this.rest
      .getCall(ApiEndpoint.OPTION_LICENSE, true, { tenantId });
  }

  public setOption(option: OptionLicense): Observable<OptionLicense> {
    return this.rest.postCall(ApiEndpoint.OPTION_LICENSE_UPDATE, option);
  }

  public deleteOption(optionId: string): Observable<OptionLicense> {
    return this.rest.deleteCall(ApiEndpoint.OPTION_LICENSE_DELETE, {
      optionId,
    });
  }

  public getOptionsNames(tenantId: string): string[] {
    const list: string[] = [];
    this.getOptions(tenantId)
      .subscribe((u: any) => {
        u._embedded.licenseOption.forEach((option: OptionLicense) => {
          list.push(option.optionName);
        });
      });
    return list;
  }

  public deleteTenant(tenantId: string): Observable<TenantLicense> {
    return this.rest.deleteCall(ApiEndpoint.TENANT_LICENSE_UPDATE, {
      tenantId,
    });
  }
}
